module.exports = __webpack_public_path__ + "67d308a52032297c8d1c44688d91e237.svg";